import LegalDocumentEditor from "components/LegalDocumentEditor";
import { getPrivacyPolicy, updatePrivacyPolicy } from "services/apiService";

function PrivacyPolicy() {
  return (
    <LegalDocumentEditor
      pageTitle="Privacy Policy"
      fetchContent={getPrivacyPolicy}
      saveContent={updatePrivacyPolicy}
    />
  );
}

export default PrivacyPolicy;
